/*-----------------------------------------------------------------
- Comments From
-----------------------------------------------------------------*/
export default {
    no_comment: 'No Visit Not Registered!',

    message: {
        success: 'Your comment was successfully sent.',
        error  : 'Problem on Register',
    },
};
